import { useRef } from 'react';

type PaginationMode = 'offset' | 'token' | 'unknown';

type PaginationSequence = { id: number; key: string; mode: PaginationMode; tokens: Map<number, string> };

const createSequence = (key: string, id: number): PaginationSequence => {
    return { id, key, mode: 'unknown', tokens: new Map() };
};

export const usePaginationState = (sequenceKey: string) => {
    const sequence = useRef(createSequence(sequenceKey, 0));

    if (sequence.current.key !== sequenceKey) {
        sequence.current = createSequence(sequenceKey, sequence.current.id + 1);
    }

    return {
        isCurrent(sequenceId: number) {
            return sequenceId === sequence.current.id;
        },
        get mode() {
            return sequence.current.mode;
        },
        recordPage(sequenceId: number, page: number, nextToken?: string) {
            if (sequenceId !== sequence.current.id) {
                return;
            }

            if (sequence.current.mode === 'unknown' && page === 0) {
                sequence.current.mode = nextToken === undefined ? 'offset' : 'token';
            }

            if (sequence.current.mode === 'token') {
                sequence.current.tokens.set(page + 1, nextToken ?? '');
            }
        },
        get sequenceId() {
            return sequence.current.id;
        },
        tokenForPage(page: number) {
            return sequence.current.tokens.get(page);
        },
    };
};
